import { useAuthStore } from '@/stores/AuthStore'
import { FilesService } from '@/api/client'
import { Filesystem } from '@capacitor/filesystem'

export default class FileManager {
  static async upload(uri: string, employee_id: number) {
    console.log('FileManager: uploading file with uri: ', uri)
    const fileResponse = await fetch(uri)
    if (fileResponse.ok) {
      const blob = await fileResponse.blob()
      return FilesService.storeFile({
        file: blob,
        size: blob.size,
        employee_id: employee_id,
      })
    }
    if (fileResponse.status === 401) {
      await useAuthStore().logout()
    }
    console.error(
      'FileManager: Unable to find the local file. \n' + fileResponse,
    )
  }
  static async inputToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const result = reader.result
        if (typeof result === 'string') {
          resolve(result)
        } else {
          reject('reader did not return a string')
        }
      }
      reader.readAsDataURL(file)
    })
  }

  static async delete(path: string) {
    if (path.length > 0) {
      await Filesystem.deleteFile({
        path: path,
      })
    }
  }
}
